import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {graphql, withApollo} from 'react-apollo'
import {AvForm, AvField, AvGroup} from 'availity-reactstrap-validation'
import {Button, CardBody, Col, Row, Label, Input} from 'reactstrap'
import {createOrUpdatePersonsMutation} from './mutations'
import CreatableSelect from '../Wps/CreatableSelect'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'
import Comments from '../Comments/Comments'
import {getUserPermissions} from '../../utils/userPermissions'
import {UploadOrReplaceFiles} from '../../utils/uploadFiles'
import ImageCrop from '../Support/ImageCrop'
import {API_BASE_URL} from '../../utils/apiConfig'

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formShouldBeDisabled: props.formShouldBeDisabled || !!(props.editData.anonymized_at || !getUserPermissions('core.people.update')),
      validation_errors: null,
      active: props.editData.active === true,
      group_ids: props.editData.group_ids || [],
      company_ids: props.editData.company_ids || [],
      newObjectSavedId: null,
      imageCropSaveFunc: null
    }

    this.submitFunction = this.submitFunction.bind(this)
  }

  static propTypes = {
    formShouldBeDisabled: PropTypes.bool,
    client: PropTypes.object.isRequired,
    mutate: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    afterSubmit: PropTypes.func,
    clearFunction: PropTypes.func,
    editData: PropTypes.object,
    permissionGroupsData: PropTypes.array,
    companiesData: PropTypes.array
  }

  componentDidMount() {
    if(this.state.formShouldBeDisabled) {
      // eslint-disable-next-line react/no-find-dom-node
      findDOMNode(this).querySelectorAll('#person-form input').forEach(a => a.setAttribute('disabled', 'true'))
    }

    // withGaTracker(window.location.pathname + '/person_form') // GA TRACKER
  }

  componentWillUnmount() {
    this.props.clearFunction && this.props.clearFunction()
  }

  submitFunction(e, values) {
    this.props.mutate({
      variables: {
        id: this.props.editData ? this.props.editData.id : null,
        ...values,
        active: this.state.active,
        group_ids: this.state.group_ids,
        company_ids: this.state.company_ids
      },
      refetchQueries: ({data: {createOrUpdatePersons}}) =>
        (!this.props.editData.id && !createOrUpdatePersons.errors) ? ['PeopleListQuery'] : []
    }).then(({data: { createOrUpdatePersons }}) => {
      if (createOrUpdatePersons.errors) {
        // withGaEvent({category: 'Person', action: 'error save'}) // GA EVENT
        this.setState({validation_errors: createOrUpdatePersons.errors})
      } else {
        // withGaEvent({category: 'Person', action: 'save'}) // GA EVENT
        const objectId = createOrUpdatePersons.person.id
        // Pass new obj id to comments
        if (!this.props.editData.id) this.setState({newObjectSavedId: objectId}, () => this.props.afterSubmit())

        // ADD PHOTO FILE
        this.setState({imageCropSaveFunc: (file) => UploadOrReplaceFiles(objectId, 'Person', [file], {}, 'Attachments::ProfilePhoto')
          .then((data) => this.updatePhotoInStore(objectId, data[0]))}, () => this.props.afterSubmit())
      }
    })
  }

  updatePhotoInStore(objectId, newPhoto) {
    let PhotoFragment = gql`
    fragment PhotoParts on Person {
      photo {
        id
        url
        thumb_url
      }
    }`

    newPhoto.__typename = 'Attachment'
    this.props.client.writeFragment({
      id: `Person:${objectId}`,
      fragment: PhotoFragment,
      data: {
        photo: newPhoto,
        __typename: 'Person'
      }
    })
  }

  render() {
    return (
      <CardBody>
        {this.state.validation_errors &&
        <h4 className="errors-heading">{this.state.validation_errors.join(', ')}</h4>
        }

        <AvForm id="person-form" onValidSubmit={this.submitFunction} className="FormClassLabel">
          <Row>
            <Col md="2" style={{minWidth: '220px', minHeight: '300px'}}>
              <h6>Photo</h6>
              {this.state.formShouldBeDisabled ? <img alt='profile_photo' src={API_BASE_URL + this.props.editData.photo.url}/> :
                <ImageCrop imageUrl={this.props.editData.photo && this.props.editData.photo.id && API_BASE_URL + this.props.editData.photo.url}
                  editorHeight={200}
                  editorWidth={200}
                  saveImageFunction={this.state.imageCropSaveFunc}
                />}
            </Col>
            <Col>
              <Row md="auto">
                <Col xs="12" sm="4">
                  <AvField
                    id="uuid-person-form"
                    name="uuid"
                    label="UUID"
                    type="text"
                    value={this.props.editData.uuid || ''}
                    required
                  />
                </Col>
                <Col xs="12" sm="4">
                  <AvGroup style={{marginTop: '15px'}}>
                    <br/>
                    <Label className="form-check-label wps-label" check inline="true">
                      <Input id="active-person-form"
                        type="checkbox"
                        name="active"
                        checked={this.state.active || ''}
                        onChange={() => this.setState({active: !this.state.active})}
                      /> Active
                    </Label>
                  </AvGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="4">
                  <AvField
                    id="first-name-person-form"
                    name="first_name"
                    label="First name"
                    type="text"
                    value={this.props.editData.first_name || ''}
                    required
                  />
                </Col>
                <Col xs="12" sm="4">
                  <AvField
                    id="last-name-person-form"
                    name="last_name"
                    label="Last Name"
                    type="text"
                    value={this.props.editData.last_name || ''}
                    required
                  />
                </Col>
                <Col xs="12" sm="4">
                  <AvField name="date_of_birth" id="date-birth-person-form"
                    label="Date of birth"
                    type="date"
                    value={this.props.editData.date_of_birth || ''}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="2">
                  <AvField id="post-code-person-form" name="post_code" label="Post code"
                    value={this.props.editData.post_code || ''}/>
                </Col>
                <Col xs="12" sm="3">
                  <AvField id="city-person-form" name="city" label="City" value={this.props.editData.city || ''}/>
                </Col>
                <Col xs="12" sm="3">
                  <AvField id="street-person-form" name="street" label="Street" value={this.props.editData.street || ''}/>
                </Col>
                <Col xs="12" sm="2">
                  <AvField id="street-no--person-form" name="street_no" label="Street number"
                    value={this.props.editData.street_no || ''}/>
                </Col>
                <Col xs="12" sm="2">
                  <AvField id="flat-no-person-form" name="street_no_flat" label="Flat number"
                    value={this.props.editData.street_no_flat || ''}/>
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="4">
                  <AvField id="phone-person-form" name="phone" label="Phone" value={this.props.editData.phone || ''}/>
                </Col>
                <Col xs="12" sm="4">
                  <AvField id="internal-phone-person-form" name="internal_phone" label="Internal phone"
                    value={this.props.editData.internal_phone || ''}/>
                </Col>
                <Col xs="12" sm="4">
                  <AvField id="mobile-phone-person-form" name="mobile_phone" label="Mobile phone"
                    value={this.props.editData.mobile_phone || ''}/>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xs="12" sm="6">
              <CreatableSelect label="Groups" id="select-groups-person-form"
                options={this.props.permissionGroupsData || this.props.editData.groups}
                valueKey="id"
                value={this.state.group_ids}
                multi={true}
                disabled={this.state.formShouldBeDisabled}
                creatable={false}
                valueChangeFunction={(val) => {
                  this.setState({group_ids: val.map(o => o.id)})
                }}/>
            </Col>
            <Col xs="12" sm="6">
              <CreatableSelect label="Companies" id="select-companies-person-form"
                options={this.props.companiesData || this.props.editData.companies}
                valueKey="id"
                value={this.state.company_ids}
                multi={true}
                creatable={false}
                disabled={this.state.formShouldBeDisabled}
                valueChangeFunction={(val) => {
                  this.setState({company_ids: val.map(o => o.id)})
                }}/>
            </Col>
          </Row>
          <br/>
          {this.props.onClose && <Button id="close-person-form-btn" color="danger" className="float-right"
            onClick={this.props.onClose}>
            <i className="fa fa-close"/> Close
          </Button>}
          {this.props.afterSubmit && !this.props.editData.anonymized_at && getUserPermissions('core.people.update') &&
            <Button id="save-person-form-btn" type="submit" color="primary" className="float-right">
              <i className="fa fa-plus"/> Save
            </Button>}
        </AvForm>
        <br/><br/>
        {getUserPermissions('core.comments.index') &&
        <Comments commentableId={this.props.editData.id || this.state.newObjectSavedId} commentableType='Person'/>}
      </CardBody>
    )
  }
}

const FormWithMutation = graphql(createOrUpdatePersonsMutation)(Form)

export default withApollo(FormWithMutation)



// WEBPACK FOOTER //
// ./src/components/People/Form.js